export default __webpack_public_path__ + "static/media/avatar_1.b740facb.svg";